export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';
export const SEND_NOTIFICATION_REQUEST = 'SEND_NOTIFICATION_REQUEST';
export const SEND_NOTIFICATION_SUCCESS = 'SEND_NOTIFICATION_SUCCESS';
export const SEND_NOTIFICATION_FAILURE = 'SEND_NOTIFICATION_FAILURE';
export const DELETE_NOTIFICATION_REQUEST = 'DELETE_NOTIFICATION_REQUEST';
export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';
export const DELETE_NOTIFICATION_FAILURE = 'DELETE_NOTIFICATION_FAILURE';
export const FETCH_COLLEGES_LIST_REQUEST = 'FETCH_COLLEGES_LIST_REQUEST';
export const FETCH_COLLEGES_LIST_SUCCESS = 'FETCH_COLLEGES_LIST_SUCCESS';
export const FETCH_COLLEGES_LIST_FAILURE = 'FETCH_COLLEGES_LIST_FAILURE';
export const FETCH_COURSES_LIST_REQUEST = 'FETCH_COURSES_LIST_REQUEST';
export const FETCH_COURSES_LIST_SUCCESS = 'FETCH_COURSES_LIST_SUCCESS';
export const FETCH_COURSES_LIST_FAILURE = 'FETCH_COURSES_LIST_FAILURE';